import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const I18nContext = createContext(null);

const LANGS = ["fi", "en", "sv"];

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem("lang") : null;
    return LANGS.includes(stored) ? stored : "fi";
  });

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const parts = path.split(".");
    let cur = translations[lang];
    for (const p of parts) {
      if (cur == null) return path;
      cur = cur[p];
    }
    return cur ?? path;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
